export const PRIVACY_STATUS_CODES = Object.freeze([
  "active", "partial", "pending", "withdrawn_or_refused",
  "other_basis", "undocumented", "not_applicable",
]);

const STATUS_CONFIG = Object.freeze({
  active: { color: "success", icon: "mdi-shield-check-outline" },
  partial: { color: "warning", icon: "mdi-shield-half-full" },
  pending: { color: "warning", icon: "mdi-clock-outline" },
  withdrawn_or_refused: { color: "error", icon: "mdi-shield-off-outline" },
  other_basis: { color: "info", icon: "mdi-scale-balance" },
  undocumented: { color: undefined, icon: "mdi-shield-alert-outline" },
  not_applicable: { color: "secondary", icon: "mdi-shield-outline" },
});

export const normalizePrivacyStatus = (value) => {
  const normalized = String(value || "").trim().toLowerCase();
  return PRIVACY_STATUS_CODES.includes(normalized) ? normalized : "undocumented";
};

export const resolvePrivacyStatus = (value) => {
  const code = normalizePrivacyStatus(value);
  return {
    code,
    ...STATUS_CONFIG[code],
    labelKey: `ncrm.contacts.dataProtection.states.${code}`,
  };
};

export const normalizePrivacyBreakdown = (value) => {
  if (!value) return {};
  try {
    const parsed = typeof value === "string" ? JSON.parse(value) : value;
    if (!parsed || Array.isArray(parsed) || typeof parsed !== "object") return {};
    return Object.fromEntries(Object.entries(parsed).filter(([, count]) => Number(count) > 0));
  } catch (_) {
    return {};
  }
};

export const buildPrivacyStatusTooltip = ({ t, state, breakdown, total, unclassified }) => {
  const status = resolvePrivacyStatus(state);
  const parts = [t(status.labelKey)];
  const entries = Object.entries(normalizePrivacyBreakdown(breakdown));
  if (entries.length) {
    parts.push(entries.map(([key, count]) =>
      `${t(`ncrm.contacts.dataProtection.breakdown.${key}`)}: ${Number(count)}`
    ).join(" · "));
  }
  const hasTotal = total !== null && total !== undefined && total !== "";
  if (hasTotal && Number.isFinite(Number(total))) {
    parts.push(t("ncrm.contacts.dataProtection.total", { count: Number(total) }));
  }
  if (Number(unclassified) > 0) {
    parts.push(t("ncrm.contacts.dataProtection.unclassified", { count: Number(unclassified) }));
  }
  return parts.join(". ");
};
